import styled from 'styled-components'

export const ClearAllButtonStyled = styled.button<{ $hasGrants: boolean }>`
  padding: 0;
  border: none;
  background: none;
  cursor: ${(props) => (props.$hasGrants ? 'pointer' : 'default')};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  color: ${(props) =>
    props.$hasGrants
      ? props.theme.colors.danger
      : props.theme.colors.text.secondary};
`
